import { useSaveCommonCriteria } from '@src/entities/Criteria/ui/hooks/useSaveCommonCriteria';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Modal as ModalComponent } from '@uhg-abyss/web/ui/Modal';
import React from 'react';

import { Form } from '../Form';

/**
 * Modal: Create
 *
 * This modal is used to create a new set of common criteria filters.
 *
 * @param assets
 * @param isOpen
 * @param refetch
 * @param setFocusedEntity
 * @param setIsOpen
 * @returns {Element}
 * @constructor
 */
export function Modal({
  assets = {},
  isOpen = false,
  refetch = () => {},
  setFocusedEntity = () => {},
  setIsOpen = () => {},
}) {
  const handleSave = useSaveCommonCriteria('create');

  /**
   * handleClose
   *
   * Handles the closing of the modal.
   *
   * @returns {Promise<void>}
   */
  const handleClose = () => {
    setIsOpen(false);
  };

  /**
   * handleCreate
   *
   * Saves the
   *
   * @param payload
   * @returns {Promise<void>}
   */
  const handleCreate = async (payload = {}) => {
    await handleSave(payload, refetch);
    setIsOpen(false);
  };

  return (
    <ErrorHandler location="src/features/CommonCriteria/Create/components/Modal/Modal.jsx">
      <ModalComponent isOpen={isOpen} onClose={handleClose} size="full" title="Create Common Criteria">
        <ModalComponent.Section>
          <Form
            assets={assets}
            handleClose={handleClose}
            handleSave={handleCreate}
            setFocusedEntity={setFocusedEntity}
          />
        </ModalComponent.Section>
      </ModalComponent>
    </ErrorHandler>
  );
}
